import type { AppointmentStatus } from "@/types/appointments/api-types/appointment-types";
import type { PaymentMethod } from "@/types/sales/api-types/sale-types";

export const SALES_LIST_STATUSES: AppointmentStatus[] = [
  "booked",
  "confirmed",
  "arrived",
  "left_message",
  "completed",
];

export const PAYMENT_METHOD_VALUES = [
  "cash",
  "eftpos",
  "credit_card",
  "account",
  "gift_card",
] as const satisfies readonly PaymentMethod[];

export const PAYMENT_METHOD_OPTIONS = [
  { value: "cash", label: "Cash" },
  { value: "eftpos", label: "Eftpos" },
  { value: "credit_card", label: "Credit card" },
  { value: "account", label: "Account" },
  { value: "gift_card", label: "Gift card" },
] as const satisfies ReadonlyArray<{
  value: (typeof PAYMENT_METHOD_VALUES)[number];
  label: string;
}>;

export const SALE_LINE_ROW_GRID =
  "grid grid-cols-1 items-start gap-3 sm:grid-cols-[minmax(0,1fr)_minmax(0,1fr)_7rem_2rem]";

export const SALE_PAYMENT_ROW_GRID =
  "grid grid-cols-1 items-start gap-3 sm:grid-cols-[minmax(0,1fr)_7rem_2rem]";
